import { format, addYears, subYears, subMonths } from 'date-fns'
export const today = new Date()
export const oneHundredFiftyYearsAgo = format(subYears(today, 150), 'yyyy-MM-dd')
export const fiftyYearsAgo = format(subYears(today, 50), 'yyyy-MM-dd')
export const twoYearsAgo = format(subYears(today, 2), 'yyyy-MM-dd')
export const twentyfiveMonthsAgo = format(subMonths(today, 25), 'yyyy-MM-dd')
export const oneYearFromNow = format(addYears(today, 1), 'yyyy-MM-dd')
export const todayString = format(today, 'yyyy-MM-dd')
